var _path, _g, _path2, _g2, _path3, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMoneda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_977_2706)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_977_2706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3614 0H27.5506C28.0532 0 28.455 0.3934 28.455 0.8862V4.6284H32.1188C32.62 4.6284 33.0204 5.0218 33.0204 5.516V10.094C33.0204 10.5868 32.62 10.9802 32.1188 10.9802H26.4964V14.7224V17.283C27.3 17.1346 28.154 17.0352 29.057 17.0352C35.9884 17.0352 41.6486 22.4994 41.7536 29.218V29.6688C41.6584 36.4826 35.9744 42 29.0066 42C25.5444 42 22.4322 40.6714 20.1236 38.4552H0.9016C0.4228 38.4552 0.0336 38.0968 0 37.6348V10.0268C0.0336 9.5648 0.4228 9.2092 0.9016 9.2092H7.0252V6.3518H3.3614C2.8588 6.3518 2.4598 5.9584 2.4598 5.4656V0.8862C2.4598 0.3934 2.8588 0 3.3614 0ZM4.21641 1.87031V4.72631H7.87881H7.98101H26.65V1.87031H4.21641ZM8.78008 6.45039V9.30639H25.5941H25.6431H25.6935H31.2151V6.45039H8.78008ZM1.7582 13.8865H24.693V11.0305H1.7582V13.8865ZM1.7582 15.6105V18.4651H23.1362C23.6374 18.2187 24.1918 17.9737 24.6916 17.7763V15.6105H1.7582ZM18.066 29.594C18.066 35.551 22.987 40.3754 29.0574 40.3754C35.1278 40.3754 40.0488 35.502 40.0488 29.594C40.0488 23.6356 35.1278 18.8098 29.0574 18.8098C22.987 18.8098 18.066 23.6356 18.066 29.594ZM1.80469 21.3681V23.0439H18.1651C18.8175 21.9603 19.6715 21.0265 20.6235 20.1879H1.80469V21.3681ZM1.80469 24.768V27.6254H16.4599C16.6111 26.637 16.8603 25.6542 17.2621 24.768H1.80469ZM1.80469 29.348V32.204H16.6111C16.4095 31.3164 16.3087 30.4302 16.3087 29.5468V29.348H1.80469ZM1.80469 33.9254V36.7814H18.6677C18.0139 35.8952 17.5127 34.9586 17.1123 33.9254H1.80469Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_977_2706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7.62341 49.6254H49.3776V-7.62061H-7.62341V49.6254Z",
    fill: "#0099CC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_977_2706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 22,
    width: 16,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3272 23.3375L31.6084 32.8897C31.803 32.2023 31.7624 31.4673 31.4166 30.8219C30.6634 29.4429 28.9064 28.6547 26.6482 28.6547C24.9934 28.6547 23.788 28.2123 23.3372 27.4227C23.137 27.0307 23.1846 26.6359 23.4366 26.2915C23.8874 25.6503 24.9934 25.1085 26.8988 25.3073C27.8032 25.4053 28.7566 25.7007 29.8612 26.0941L30.06 26.1431C30.5122 26.2915 31.0162 26.0451 31.166 25.6027C31.3158 25.1589 31.0652 24.6675 30.6116 24.5191L30.4128 24.4701C29.2578 24.0739 28.2036 23.7309 27.1004 23.6329C24.7918 23.3851 22.885 24.0263 21.982 25.3563C21.3786 26.2425 21.2792 27.3261 21.7804 28.2599C22.5336 29.6389 24.2892 30.3781 26.6482 30.3781C28.2554 30.3781 29.4594 30.8219 29.8612 31.6101C30.06 32.0021 30.06 32.3983 29.759 32.7903C29.36 33.3825 28.2036 33.9733 26.3472 33.7269C25.4442 33.6303 24.4894 33.3321 23.4366 32.9891L23.235 32.9415C22.7842 32.7903 22.283 33.0381 22.1332 33.4791C21.982 33.9243 22.2326 34.4157 22.6848 34.5641L22.885 34.6131C23.9882 34.9589 25.0928 35.3523 26.1456 35.4503C26.497 35.4993 26.798 35.4993 27.1004 35.4993C28.9064 35.5469 30.4128 34.9085 31.2164 33.7773C31.3522 33.5743 31.4572 33.3573 31.5398 33.1333L30.1104 38.1565C29.9606 38.6017 30.2602 39.0945 30.7138 39.2415C30.8132 39.2415 30.865 39.2919 30.9644 39.2919C31.3662 39.2919 31.7162 39.0427 31.817 38.6521L36.0338 23.8303C36.1836 23.3375 35.8826 22.8433 35.4304 22.7453C35.3506 22.7187 35.2708 22.7075 35.1896 22.7075C34.813 22.7075 34.4518 22.9735 34.3272 23.3375Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_977_2706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8359 46.9144H43.6951V15.084H13.8359V46.9144Z",
    fill: "#0099CC"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_977_2706",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 33,
    width: 3,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9748 34.6631V34.8605C33.9244 35.3533 34.3248 35.7467 34.7756 35.7957H34.8288C35.2782 35.7957 35.6814 35.4513 35.6814 35.0075V34.8101C35.7808 34.3187 35.4294 33.9253 34.9282 33.8763C34.8988 33.8735 34.8708 33.8721 34.8442 33.8721C34.3822 33.8721 34.0238 34.2445 33.9748 34.6631Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_977_2706)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.347 43.4195H43.3206V26.2485H26.347V43.4195Z",
    fill: "#0099CC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_977_2706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoneda);
export default __webpack_public_path__ + "static/media/ico_moneda.3e91e63c95efe906cdda91eacd099a97.svg";
export { ForwardRef as ReactComponent };